<template>
  <wt-box :class="classes" direction="row">
    <div class="wt-segment-symbol__line"></div>
    <div class="wt-segment-symbol__content" :style="`margin:0 ${gap}`">
      <slot />
    </div>
    <div class="wt-segment-symbol__line"></div>
  </wt-box>
</template>

<script>
import wtBox from '../box'
// 组件class前缀
const prefixCls = 'wt-segment-symbol'

export default {
  name: 'wt-segment-symbol',
  props: {
    gap: {
      type: String,
      default: '10px'
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    wtBox
  }
}
</script>

<style lang="less">
/* 务必遵循css BEM原则 */
.wt-segment-symbol{
  &__line{
    flex:1;
    border-top:1px solid currentColor;
  }
}
</style>
